module.exports = __webpack_public_path__ + "img/payment.70e9458a.svg";